import { useCallback, useEffect, useState } from 'react';
import debounce from 'lodash/debounce';

export type UseDocumentScrollHeightReturn = {
	scrollY: number | null;
};

export const useDocumentScrollHeight = (isLivePage = false): UseDocumentScrollHeightReturn => {
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (process.env.REACT_SSR) {
		return { scrollY: 0 };
	} else {
		// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
		const newViewPageContainer = document.getElementById('AkMainContent');
		const [scrollHeightAttributes, setScrollHeightAttributes] =
			// eslint-disable-next-line react-hooks/rules-of-hooks
			useState<UseDocumentScrollHeightReturn>({
				scrollY: 0,
			});

		// eslint-disable-next-line react-hooks/rules-of-hooks
		const handleScroll = useCallback(() => {
			// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
			const livePageContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
			const viewPageScrollY = newViewPageContainer
				? newViewPageContainer.scrollTop
				: window.scrollY;

			setScrollHeightAttributes({
				scrollY: isLivePage ? livePageContainer && livePageContainer.scrollTop : viewPageScrollY,
			});
		}, [setScrollHeightAttributes, isLivePage, newViewPageContainer]);

		// eslint-disable-next-line react-hooks/rules-of-hooks
		useEffect(() => {
			const livePageContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
			const debounceScroll = debounce(handleScroll, 250);

			if (isLivePage) {
				livePageContainer?.addEventListener('scroll', debounceScroll);
			} else {
				newViewPageContainer
					? newViewPageContainer?.addEventListener('scroll', debounceScroll)
					: document.addEventListener('scroll', debounceScroll);
			}

			return () => {
				if (isLivePage) {
					livePageContainer?.removeEventListener('scroll', debounceScroll);
				} else {
					newViewPageContainer
						? newViewPageContainer?.removeEventListener('scroll', debounceScroll)
						: document.removeEventListener('scroll', debounceScroll);
				}
			};
			// eslint-disable-next-line react-hooks/exhaustive-deps
		}, []);

		return scrollHeightAttributes;
	}
};
